export default {
	SiteTitle : 'Fleet Shoft'
}